/**
 * まとまり（iOS の Inset Grouped。#151、docs/60 §2・§6・§8）。会社の切替から使い始め、ほかの画面にも広げる部品（docs/60 §8 の順で1つずつ）。
 *   ・GroupSection：節＝見出し（14px 太字 薄墨、左に角印 20px）・まとまり（children に GroupList）・注（14px 薄墨）。見出しが無ければ出さない
 *   ・GroupList：白いまとまり（<ul>。机の地に角丸 12px・影だけ・枠線なし）。plain＝アイコンの無い行（区切りの線を 16px から。ふつうは字の頭＝68px から）
 *   ・GroupRow：行（60px 以上。左＝アイコン 40px、中＝主の字（1行・末尾「…」）＋下の字、右＝しるし）。押せる行は中身を <button>、押せない行は <div>。
 *     区切りの線は CSS（隣り合う行の ::before）。DOM は 字 → アイコン → しるし の順（アイコンは CSS の order で左に置く）＝行の文字（innerText）の1行目が主の字
 *     （アイコンは読み上げないが、頭文字は文字なので innerText に入る）
 *   ・並べ替え（「編集」の中だけ。docs/10 §5.5＝ドラッグだけにしない）：
 *       つまみ（GripButton）を押さえて上下に動かす＝useRowDrag（Pointer Events。6px 動いたらドラッグ、節の中だけ、入る場所に藍の線）
 *       つまみを押す（動かさずに離す）・Enter・Space＝MoveMenu（一番上へ／上へ／下へ／一番下へ。端では押せない）
 *   ・useFlip：並びが変わったとき、前の位置から 200ms（--t-move）で動かす（FLIP）。動きを減らす設定なら動かさない
 * 見た目は styles.css の「会社の切替（#151）」の節（.gsec・.glist・.grow・.ggrip・.gmenu）
 *
 * 設定の行（#152、docs/61 §5、Figma「アカウントと氏名（10/8）」部品の「設定の行」。52px・区切りは 字の頭から＝絵があれば 58px、無ければ 16px）：
 *   ・GroupNavRow（進む）：左に行の絵（RowIcon 30px）・名前、右に値（薄墨）と ›。押すと別の画面・シートへ（to＝リンク、onClick＝ボタン）
 *   ・GroupValueRow（値）：名前と、右に値（見るだけ）か部品（セグメントなど。押した瞬間に効くもの）
 *   ・GroupInputRow（入力）：左に名前（薄墨）、右に入力の欄（枠なし。入力中は行の内側に藍の輪）
 *   ・GroupDangerRow（朱）：真ん中に朱の字（ログアウトなど）。まとまりを分けて一番下に
 *   menu＝アカウントのメニューの中（押せるものに role="menuitem"。↓↑ はメニューが回す）
 *   見た目は styles.css の「アカウントと氏名（#152）」の節（.grow-set・.rowico・.gval・.gchev・.grow-in・.grow-danger）
 *
 * 設定と自社情報（#153、docs/62 §2・§3・§7、Figma「設定と自社情報（10/9）」左上の部品）：
 *   ・GroupHeadRow（会社の頭の行）：会社のアイコン 56・会社名（太字 18）・下の字（薄墨 14）・›。to が無ければ押せない（担当者）
 *   ・GroupInputRow の wide：名前の幅 128px（自社情報。姓・名の 52px は今のまま）。end＝欄の右（「住所検索」）
 *   ・GroupSelectRow（選ぶ）：入力の行と同じ形（名前 128px・右に値）＋右端に上下のしるし。中身はネイティブの <select>（行全体に重ねて透明）
 *   ・GroupImageRow（画像）：左に見本 44px・名前・右に「変更」か「未登録」・›。押すとシート（画面が開く）。行に画像を落としても登録
 *   ・GroupNavRow の current（PC の2列の左の列のいまの行：地 --sel・太字・aria-current="page"）・buttonId（中のリンクの id）
 *   ・GroupDangerRow の to（退会：朱の字のリンク）
 *   見た目は styles.css の「設定と自社情報（#153）」の節（.grow-head・.grow-in.is-wide・.grow-sel・.grow-img・.grow.is-current）
 *
 * 見積・請求（#154、docs/63 §2〜§4、Figma「見積・請求（10/9）」左上の部品）：
 *   ・GroupSwitchRow（スイッチ）：左に名前（墨 16・折り返してよい）、右にトグル 52×32（2026-10-21 から「オン／オフ」の字は無い＝docs/89 ★15）。行のどこを押しても切り替わる（行が <label>）。
 *     中身は今の Switch と同じ（role="switch"・aria-checked・aria-label は短い名前・data-testid）
 *   ・GroupNumberRow（数）：左に名前、右に地 --head の欄（112×36・右寄せ・NumInput＝テンキー・全角→半角）と単位。入力中は白地に藍の輪。
 *     範囲の外は行の下に朱の1行（error）
 *   ・InstallmentRow（分割の回）：左に ⊖（朱の丸）・「n回目」（薄墨 15）・名前（行の中で入力）・割合の欄（地 --head・右寄せ・％）。最後の回は「残り」
 *   ・GroupSection の id（#unissue で送る節）、GroupDangerRow の tone="ai"（藍の字。既定に戻す）
 *   見た目は styles.css の「見積・請求（#154）」の節（.grow-sw・.grow-num・.gnum・.grow-inst）
 *
 * 振込口座（#155、docs/64 §2〜§4、Figma「振込口座（10/9）」左上の部品）：
 *   ・BankAccountRow（口座の行）：68px・左に口座の絵 40（RowIcon の bank を大きく）・1行目＝銀行名 支店名（既定は太字＋右に ✓既定）・2行目＝種別 口座番号　名義（薄墨 14）・›。
 *     行全体が押せる（to＝リンク。replace＝履歴を増やさない＝一覧の上にシートが開く）
 *   ・GroupSuggestList・GroupSuggestRow（候補の行）：入力の行のすぐ下・同じまとまりの中に 48px の行（名前と右にコード）。
 *     欄が role="combobox"（aria-activedescendant）で、↓↑ で選んだ行は地 --sel＋太字（aria-selected）。押す（Enter）とその行
 *   ・GroupTextRow（文の行）：まとまりの中に文だけ（紙の印字・以前の振込先の1行。折り返してよい）
 *   ・GroupInputRow の error（足りない欄・見つからないコード：行の下に朱の1行。欄の aria-describedby は `${id}-err`）、GroupList の id
 *   見た目は styles.css の「振込口座（#155）」の節（.grow-bank・.gdef・.grow-sugs・.grow-sug・.grow-text・.grow-in.is-error）
 *
 * 設定の残り7画面（#156、docs/65 §2、Figma「設定の残り（10/9）」左上の部品）：
 *   ・GroupCheckRow（選ぶ行）：名前（と補足）・選んでいれば名前が太字＋右に ✓（色だけで伝えない）。1つ選ぶ＝<button aria-pressed>（押した瞬間に効く）、
 *     いくつでも選ぶ（multi）＝行が <label> で中に checkbox（退会の理由・確かめ。id は中の checkbox に）。after＝行の右に重ねるもの（帳票の「修正」）
 *   ・GroupTwoLineRow（2行の行）：名前と補足の2行＋›（行全体がリンク）。editing＝左に ⊖（朱の丸）・› を隠す（見積の雛形・自分の書式の削除）
 *   ・UserRow（ユーザーの行）：64px・人のアイコン 40・氏名・2行目（権限と最後のログイン／招待中／使えない）・›。dim＝行全体を薄く（使えない人）。
 *     行全体がリンク（replace＝一覧の上にシートが開く。#155 の口座の行と同じ）
 *   ・RemoveButton（⊖）：分割の回の行と同じ朱の丸（押せる範囲 44）
 *   見た目は styles.css の「設定の残り（#156）」の節（.grow-chk・.grow-two・.grow-user・.ginst-rm）
 */
import { Children, cloneElement, isValidElement, useEffect, useId, useLayoutEffect, useRef, useState, type CSSProperties, type KeyboardEvent as ReactKeyboardEvent, type PointerEvent as ReactPointerEvent, type ReactNode, type Ref, type RefObject } from "react";
import { Link } from "react-router";
import { NumInput } from "./NumInput.jsx";

/** data-testid・data-co など（節・まとまり・行の外側の要素にそのまま付ける） */
export type DataAttrs = { [k: `data-${string}`]: string | undefined };

const join = (...xs: Array<string | false | null | undefined>) => xs.filter(Boolean).join(" ");

/** 動きを減らす設定（OS の「視差効果を減らす」）。CSS も全部止めるが、FLIP の位置の書き換えもしない */
export function reduceMotion(): boolean {
  return window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ?? false;
}

/** 節：見出し（あれば）・まとまり（children）・注（あれば）。help＝見出しの右の「？」（#153、docs/62 §3。見出しの名前には入れない）。id＝節の id（#unissue で送る。#154） */
export function GroupSection({ id: sectionId, title, icon, help, note, children, className, titleTestId, ...data }: { id?: string | undefined; title?: ReactNode; /** 見出しの左の角印（20px の画像の URL） */ icon?: string | undefined; help?: ReactNode; note?: ReactNode; children: ReactNode; className?: string | undefined; /** 見出しの data-testid */ titleTestId?: string | undefined } & DataAttrs) {
  const id = useId();
  return (
    <section id={sectionId} className={join("gsec", className)} aria-labelledby={title ? id : undefined} {...data}>
      {title ? (
        <div className="gsechead">
          <h2 id={id} data-testid={titleTestId}>
            {icon ? <img src={icon} alt="" width={20} height={20} /> : null}
            <span>{title}</span>
          </h2>
          {help}
        </div>
      ) : null}
      {children}
      {note ? <p className="gsecnote">{note}</p> : null}
    </section>
  );
}

/** 白いまとまり（<ul>）。plain＝アイコンの無い行（区切りの線を左 16px から）。id＝まとまりの id（振込口座の一覧 #bankAccountList。#155） */
export function GroupList({ id, children, plain = false, className, ...data }: { id?: string | undefined; children: ReactNode; plain?: boolean; className?: string | undefined } & DataAttrs) {
  return (
    <ul id={id} className={join("glist", plain && "glist-plain", className)} {...data}>
      {children}
    </ul>
  );
}

export type GroupRowProps = {
  /** 左のアイコン（40px。会社なら CompanyIcon） */
  icon?: ReactNode;
  /** 主の字（1行・末尾「…」） */
  title: ReactNode;
  /** 主の字の data-testid */
  titleTestId?: string | undefined;
  /** 下の字（14px） */
  sub?: ReactNode;
  /** 右のしるし（✓・↗・「前回」・回る印） */
  end?: ReactNode;
  /** あれば中身を <button> にする（押せる行）。無ければ <div> */
  onClick?: (() => void) | undefined;
  disabled?: boolean | undefined;
  /** 選ぶ行（並び順の「よく使う順」など）：aria-pressed（太字は CSS） */
  pressed?: boolean | undefined;
  /** 待っている行：aria-busy */
  busy?: boolean | undefined;
  /** いまの行：aria-current="true" */
  current?: boolean | undefined;
  /** 中の <button> の data-testid（行そのものは data-testid で） */
  buttonTestId?: string | undefined;
  className?: string | undefined;
  style?: CSSProperties | undefined;
  rowRef?: Ref<HTMLLIElement> | undefined;
  /** 中身の右に並べるもの（つまみ）と、行に重ねるもの（メニュー） */
  after?: ReactNode;
} & DataAttrs;

export function GroupRow({ icon, title, titleTestId, sub, end, onClick, disabled, pressed, busy, current, buttonTestId, className, style, rowRef, after, ...data }: GroupRowProps) {
  const inner = (
    <>
      <span className="gtx">
        <span className="gtt" data-testid={titleTestId}>
          {title}
        </span>
        {sub ? <span className="gsb">{sub}</span> : null}
      </span>
      {icon ? <span className="gico">{icon}</span> : null}
      {end ? <span className="gend">{end}</span> : null}
    </>
  );
  return (
    <li ref={rowRef} className={join("grow", className)} style={style} aria-current={current ? "true" : undefined} aria-busy={busy || undefined} {...data}>
      {onClick ? (
        <button type="button" className="growin" onClick={onClick} disabled={disabled} aria-pressed={pressed} data-testid={buttonTestId}>
          {inner}
        </button>
      ) : (
        <div className="growin" data-testid={buttonTestId}>
          {inner}
        </div>
      )}
      {after}
    </li>
  );
}

/**
 * 表示だけの値（S-00009、docs/10 §9.20 の d）：入りきらないときは「…」で切り、押すと全部（折り返して見せる）。もう一度押すと戻す。
 * 入りきっているときは押しても何もしない（読み上げも「ボタン」と言わない）
 */
export function Trunc({ children, testId }: { children: string; testId?: string | undefined }) {
  const ref = useRef<HTMLSpanElement>(null);
  const [open, setOpen] = useState(false);
  const [cut, setCut] = useState(false);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el || open) return;
    const check = () => setCut(el.scrollWidth > el.clientWidth + 1);
    check();
    const ro = typeof ResizeObserver === "function" ? new ResizeObserver(check) : null;
    ro?.observe(el);
    return () => ro?.disconnect();
  }, [children, open]);
  const toggle = () => (open || cut) && setOpen((v) => !v);
  return (
    <span
      ref={ref}
      className={join("gval trunc", open && "is-open")}
      title={cut ? children : undefined}
      role={open || cut ? "button" : undefined}
      tabIndex={open || cut ? 0 : undefined}
      aria-expanded={open || cut ? open : undefined}
      onClick={toggle}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && (e.preventDefault(), toggle())}
      data-testid={testId}
    >
      {children}
    </span>
  );
}

/** ✓（選んでいる・使用中。藍 22px） */
export function CheckMark({ testId }: { testId?: string | undefined }) {
  return (
    <svg className="gmark gmark-check" viewBox="0 0 24 24" aria-hidden="true" data-testid={testId}>
      <path d="M4.5 12.5l5 5L19.5 7" />
    </svg>
  );
}

/** 三本線のつまみの絵 */
export function GripIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M5 8h14M5 12h14M5 16h14" />
    </svg>
  );
}

// ---------------------------------------------------------------------------
// 並べ替え：つまみを押さえて上下に動かす（Pointer Events。HTML5 の draggable はスマホで効かないので使わない）
// ---------------------------------------------------------------------------

/** ドラッグ中の行：id・指についた縦のずれ（節の外へは出ない）・入る位置（つまみの行を抜いた並びの何番目か）・藍の線を引く行 */
export type RowDrag = { id: string; dy: number; to: number; target: { id: string; where: "above" | "below" } | null };

type Press = {
  id: string;
  ids: string[];
  pointerId: number;
  startY: number;
  started: boolean;
  from: number;
  rects: Array<{ id: string; top: number; bottom: number }>;
  minDy: number;
  maxDy: number;
  to: number;
};

/** 6px 以上動いたらドラッグ（それより小さければ「押した」＝メニュー） */
const DRAG_START = 6;

/**
 * つまみのドラッグ。rowRef(id) を行（li）に、gripProps(id, ids) をつまみのボタンに付ける（ids＝同じ節で動かせる行の id を表示の順に）。
 *   onDrop(id, to)：離したとき（to＝つまみの行を抜いた並びに入れる位置。動かさなかったら元の位置）。並びを変える前に useFlip の snapshot を呼べば、離した所から滑って収まる
 *   onTap(id)：動かさずに押した・Enter・Space（click）。メニューを開く
 */
export function useRowDrag({ onDrop, onTap }: { onDrop: (id: string, to: number) => void; onTap: (id: string) => void }) {
  const rows = useRef(new Map<string, HTMLElement>());
  const [drag, setDrag] = useState<RowDrag | null>(null);
  const press = useRef<Press | null>(null);
  /** ドラッグのあとに来る click でメニューを開かない */
  const suppress = useRef(false);
  const cb = useRef({ onDrop, onTap });
  cb.current = { onDrop, onTap };

  const rowRef = (id: string) => (el: HTMLLIElement | null) => {
    if (el) rows.current.set(id, el);
    else rows.current.delete(id);
  };

  const gripProps = (id: string, ids: string[]) => ({
    onPointerDown: (e: ReactPointerEvent<HTMLElement>) => {
      if (e.pointerType === "mouse" && e.button !== 0) return;
      e.currentTarget.setPointerCapture?.(e.pointerId);
      press.current = { id, ids, pointerId: e.pointerId, startY: e.clientY, started: false, from: 0, rects: [], minDy: 0, maxDy: 0, to: 0 };
    },
    onPointerMove: (e: ReactPointerEvent<HTMLElement>) => {
      const p = press.current;
      if (!p || p.pointerId !== e.pointerId) return;
      const raw = e.clientY - p.startY;
      if (!p.started) {
        if (Math.abs(raw) < DRAG_START) return;
        // 動かし始め：節の行の位置を1回だけ測る（動かすあいだ、ほかの行は動かさない＝入る場所は線で見せる）
        p.rects = p.ids.flatMap((x) => {
          const el = rows.current.get(x);
          if (!el) return [];
          const r = el.getBoundingClientRect();
          return [{ id: x, top: r.top, bottom: r.bottom }];
        });
        p.from = p.rects.findIndex((r) => r.id === p.id);
        if (p.from < 0 || p.rects.length < 2) return;
        const me = p.rects[p.from]!;
        p.minDy = p.rects[0]!.top - me.top;
        p.maxDy = p.rects[p.rects.length - 1]!.bottom - me.bottom;
        p.to = p.from;
        p.started = true;
      }
      e.preventDefault();
      const dy = Math.min(p.maxDy, Math.max(p.minDy, raw));
      const me = p.rects[p.from]!;
      const mid = (me.top + me.bottom) / 2 + dy;
      const others = p.rects.filter((_, i) => i !== p.from);
      const to = others.filter((r) => (r.top + r.bottom) / 2 < mid).length;
      p.to = to;
      const target = to === p.from ? null : to < others.length ? { id: others[to]!.id, where: "above" as const } : { id: others[others.length - 1]!.id, where: "below" as const };
      setDrag({ id: p.id, dy, to, target });
    },
    onPointerUp: (e: ReactPointerEvent<HTMLElement>) => {
      const p = press.current;
      if (!p || p.pointerId !== e.pointerId) return;
      press.current = null;
      if (!p.started) return; // 動かさなかった＝このあとの click でメニュー
      suppress.current = true;
      window.setTimeout(() => {
        suppress.current = false;
      }, 0);
      setDrag(null);
      cb.current.onDrop(p.id, p.to);
    },
    onPointerCancel: () => {
      press.current = null;
      setDrag(null);
    },
    onLostPointerCapture: () => {
      if (press.current?.started) setDrag(null);
      press.current = null;
    },
    onClick: () => {
      if (suppress.current) {
        suppress.current = false;
        return;
      }
      cb.current.onTap(id);
    },
  });

  return { drag, rows, rowRef, gripProps };
}

/** 行の右のつまみ（三本線・薄墨・44px）。読み上げの名前は label（「○○の並びを変える」）、押すとメニュー（aria-haspopup="menu"） */
export function GripButton({ label, expanded, gripRef, testId, ...handlers }: { label: string; expanded: boolean; gripRef?: Ref<HTMLButtonElement> | undefined; testId?: string | undefined } & ReturnType<ReturnType<typeof useRowDrag>["gripProps"]>) {
  return (
    <button type="button" ref={gripRef} className="ggrip" aria-label={label} title={label} aria-haspopup="menu" aria-expanded={expanded} data-testid={testId} {...handlers}>
      <GripIcon />
    </button>
  );
}

/**
 * 並びが変わったときの動き（FLIP）。snapshot() を並びを変える前に呼ぶと、次の描画で前の位置から 200ms で今の位置へ動かす。
 * 動きを減らす設定なら何もしない（CSS も transition を止める）
 */
export function useFlip(rows: RefObject<Map<string, HTMLElement>>) {
  const from = useRef<Map<string, number> | null>(null);
  const timer = useRef<number | undefined>(undefined);
  useLayoutEffect(() => {
    const f = from.current;
    if (!f) return;
    from.current = null;
    const moved: HTMLElement[] = [];
    rows.current.forEach((el, id) => {
      const old = f.get(id);
      if (old == null) return;
      const d = old - el.getBoundingClientRect().top;
      if (Math.abs(d) < 1) return;
      el.style.transition = "none";
      el.style.transform = `translateY(${d}px)`;
      moved.push(el);
    });
    if (!moved.length) return;
    void document.body.offsetHeight; // 戻した位置を一度描かせる
    for (const el of moved) {
      el.style.transition = "transform var(--t-move) var(--ease)";
      el.style.transform = "";
    }
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => moved.forEach((el) => el.style.removeProperty("transition")), 260);
  });
  useEffect(() => () => window.clearTimeout(timer.current), []);
  return () => {
    if (reduceMotion()) return;
    const m = new Map<string, number>();
    rows.current.forEach((el, id) => m.set(id, el.getBoundingClientRect().top));
    from.current = m;
  };
}

// ---------------------------------------------------------------------------
// つまみのメニュー（一番上へ／上へ／下へ／一番下へ）
// ---------------------------------------------------------------------------

export type MoveKind = "top" | "up" | "down" | "bottom";

const MOVE_ICON: Record<MoveKind, ReactNode> = {
  top: <path d="M5 4h14M12 20V9M7 13l5-5 5 5" />,
  up: <path d="M12 20V5M6 11l6-6 6 6" />,
  down: <path d="M12 4v15M6 13l6 6 6-6" />,
  bottom: <path d="M5 20h14M12 4v11M7 11l5 5 5-5" />,
};

/**
 * つまみを押したときのメニュー（role="menu"。行の下・右寄せ。Figma ③）。開くと押せる最初の項目へ、↑↓・Home・End で移る、
 * Esc・外を押すと閉じる（つまみへ focus を戻す）、Tab で閉じる。端では押せない（aria-disabled。押しても何もしない）
 */
export function MoveMenu({ label, labels, canUp, canDown, onMove, onClose, anchor, testId }: {
  /** メニューの名前（読み上げ） */
  label: string;
  labels: Record<MoveKind, string>;
  canUp: boolean;
  canDown: boolean;
  onMove: (k: MoveKind) => void;
  /** focusAnchor＝つまみへ focus を戻す */
  onClose: (focusAnchor: boolean) => void;
  /** 開いたつまみ（外を押したかの見分けに使う） */
  anchor: () => HTMLElement | null;
  testId?: string | undefined;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const close = useRef(onClose);
  close.current = onClose;
  const items: Array<{ k: MoveKind; on: boolean }> = [
    { k: "top", on: canUp },
    { k: "up", on: canUp },
    { k: "down", on: canDown },
    { k: "bottom", on: canDown },
  ];
  const list = () => Array.from(ref.current?.querySelectorAll<HTMLElement>('[role="menuitem"]') ?? []);
  useEffect(() => {
    const all = list();
    (all.find((el) => el.getAttribute("aria-disabled") !== "true") ?? all[0])?.focus();
    ref.current?.scrollIntoView?.({ block: "nearest" });
    const onDown = (e: PointerEvent) => {
      const t = e.target as Element | null;
      if (!t || ref.current?.contains(t) || anchor()?.contains(t)) return;
      // 外を押した：押したものが別のボタン・欄なら focus はそちらに任せる
      close.current(!t.closest?.("button,a,input,select,textarea,[tabindex]"));
    };
    document.addEventListener("pointerdown", onDown, true);
    return () => document.removeEventListener("pointerdown", onDown, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const onKey = (e: ReactKeyboardEvent<HTMLDivElement>) => {
    const all = list();
    const i = all.indexOf(document.activeElement as HTMLElement);
    const go = (j: number) => {
      e.preventDefault();
      all[(j + all.length) % all.length]?.focus();
    };
    if (e.key === "ArrowDown") go(i + 1);
    else if (e.key === "ArrowUp") go(i - 1);
    else if (e.key === "Home") go(0);
    else if (e.key === "End") go(all.length - 1);
    else if (e.key === "Escape") {
      e.preventDefault();
      e.stopPropagation();
      onClose(true);
    } else if (e.key === "Tab") onClose(false);
  };
  return (
    <div ref={ref} className="gmenu" role="menu" aria-label={label} data-testid={testId} onKeyDown={onKey}>
      {items.map(({ k, on }) => (
        <button key={k} type="button" role="menuitem" tabIndex={-1} aria-disabled={on ? undefined : "true"} onClick={() => on && onMove(k)}>
          <span>{labels[k]}</span>
          <svg viewBox="0 0 24 24" aria-hidden="true">
            {MOVE_ICON[k]}
          </svg>
        </button>
      ))}
    </div>
  );
}

// ---------------------------------------------------------------------------
// 設定の行（#152）：進む・値・入力・朱
// ---------------------------------------------------------------------------

/** 行の絵の名前（Figma の部品「アイコン/…」） */
export type RowIconKey =
  | "person" | "card" | "switch" | "text" | "logout" | "key" | "shield" | "mail" | "drawer" | "building" | "monitor" | "phone" | "plus"
  // #153（Figma の部品「アイコン/口座」〜「アイコン/工程」。lucide 相当）。toggle＝使う機能（アイコン/スイッチ。switch は会社の切替の矢印）
  | "bank" | "users" | "toggle" | "calc" | "doc" | "copy" | "send" | "layout" | "tag" | "calendar" | "gantt"
  // #164：単位（定規）
  | "ruler"
  // #191：テーマ色（パレット）・明るさ（半分塗りの丸）
  | "palette"
  | "contrast"
  // #268 1.5b：帳票番号（#）
  | "hash"
  // #268 1.5c-1：データの取込（箱に入る矢印）
  | "upload";

const ROW_ICON: Record<RowIconKey, ReactNode> = {
  person: (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21a8 8 0 0 1 16 0" />
    </>
  ),
  card: (
    <>
      <rect x="2.5" y="5" width="19" height="14" rx="2" />
      <path d="M2.5 10h19" />
    </>
  ),
  switch: <path d="M4 8h14l-3-3M20 16H6l3 3" />,
  text: <path d="M4 7V5h11v2M9.5 5v14M7 19h5M14 12v-1.5h7V12M17.5 10.5V19M16 19h3" />,
  logout: <path d="M14 4h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4M10 16l-4-4 4-4M6 12h10" />,
  key: (
    <>
      <circle cx="7.5" cy="15.5" r="3.5" />
      <path d="M10 13l9-9M16 7l2.5 2.5M14 9l2 2" />
    </>
  ),
  shield: <path d="M12 3l7 3v5.5c0 4.4-3 8-7 9.5-4-1.5-7-5.1-7-9.5V6zM9 12l2 2 4-4" />,
  mail: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3.5 6.5L12 13l8.5-6.5" />
    </>
  ),
  drawer: (
    <>
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="M15 4v16" />
    </>
  ),
  building: <path d="M4 21V5.5L12 3v18M12 21V9l8 2.5V21M2.5 21h19M7 8h2M7 12h2M7 16h2M15 13h2M15 17h2" />,
  monitor: (
    <>
      <rect width="20" height="14" x="2" y="3" rx="2" />
      <path d="M8 21h8M12 17v4" />
    </>
  ),
  phone: (
    <>
      <rect width="14" height="20" x="5" y="2" rx="2" />
      <path d="M12 18h.01" />
    </>
  ),
  plus: <path d="M12 5v14M5 12h14" />,
  bank: <path d="M3 21h18M6 17.5V11M10 17.5V11M14 17.5V11M18 17.5V11M12 3l8.5 5h-17z" />,
  users: (
    <>
      <circle cx="9" cy="8" r="3.5" />
      <path d="M2.5 20a6.5 6.5 0 0 1 13 0M16 4.6a3.5 3.5 0 0 1 0 6.8M18.5 14.4a6.5 6.5 0 0 1 3 5.6" />
    </>
  ),
  toggle: (
    <>
      <rect x="2.5" y="7" width="19" height="10" rx="5" />
      <circle cx="16.5" cy="12" r="2.2" />
    </>
  ),
  calc: (
    <>
      <rect x="5" y="2.5" width="14" height="19" rx="2" />
      <path d="M8.5 6.5h7M8.5 11h.01M12 11h.01M15.5 11h.01M8.5 14.5h.01M12 14.5h.01M15.5 14.5h.01M8.5 18h.01M12 18h.01M15.5 18h.01" />
    </>
  ),
  doc: <path d="M14 2.5H7a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7.5zM14 2.5v5h5M9 12.5h6M9 16.5h6" />,
  copy: (
    <>
      <rect x="8.5" y="8.5" width="12.5" height="12.5" rx="2" />
      <path d="M15.5 8.5V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v8.5a2 2 0 0 0 2 2h3.5" />
    </>
  ),
  send: <path d="M21 3L10.5 13.5M21 3l-6.5 18-4-7.5L3 9.5z" />,
  layout: (
    <>
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <path d="M3 9h18M9 21V9" />
    </>
  ),
  tag: (
    <>
      <path d="M12.6 2.6A2 2 0 0 0 11.2 2H4a2 2 0 0 0-2 2v7.2a2 2 0 0 0 .6 1.4l8.7 8.7a2.4 2.4 0 0 0 3.4 0l6.6-6.6a2.4 2.4 0 0 0 0-3.4z" />
      <path d="M7.5 7.5h.01" />
    </>
  ),
  calendar: (
    <>
      <rect x="3" y="4.5" width="18" height="16.5" rx="2" />
      <path d="M3 10h18M8 2.5v4M16 2.5v4" />
    </>
  ),
  gantt: <path d="M4 6h7M8 12h12M6 18h8" />,
  ruler: <path d="M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.4 2.4 0 0 1 0-3.4l2.6-2.6a2.4 2.4 0 0 1 3.4 0zM14.5 12.5l2-2M11.5 9.5l2-2M8.5 6.5l2-2M17.5 15.5l2-2" />,
  palette: (
    <>
      <path d="M12 2.5a9.5 9.5 0 0 0 0 19c1 0 1.6-.7 1.6-1.6 0-.5-.2-.9-.5-1.2-.3-.3-.5-.7-.5-1.2 0-.9.7-1.6 1.6-1.6h1.9a5.4 5.4 0 0 0 5.4-5.4c0-4.4-4.3-8-9.5-8z" />
      <circle cx="7.5" cy="11.5" r="1.2" />
      <circle cx="10" cy="7.2" r="1.2" />
      <circle cx="15" cy="7.2" r="1.2" />
    </>
  ),
  contrast: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 3a9 9 0 0 1 0 18z" fill="currentColor" />
    </>
  ),
  hash: <path d="M4 9h16M4 15h16M10 3L8 21M16 3l-2 18" />,
  upload: <path d="M12 3v12M7 10l5 5 5-5M4 15v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-4" />,
};

/** 行の絵（30px の角丸の四角・地 --sel・藍の線）。読み上げない。size＝40（口座の行）・56（振込口座のまだ無いときのカード）。#155 */
export function RowIcon({ k, size = 30 }: { k: RowIconKey; size?: 30 | 40 | 56 }) {
  return (
    <span className={join("rowico", size !== 30 && `is-${size}`)} aria-hidden="true">
      <svg viewBox="0 0 24 24">{ROW_ICON[k]}</svg>
    </span>
  );
}

/** ›（進む行の右） */
export function Chevron() {
  return (
    <svg className="gchev" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M9 5.5l6.5 6.5L9 18.5" />
    </svg>
  );
}

type SetRowBase = {
  /** 左の絵（RowIcon か PersonIcon・CompanyIcon） */
  icon?: ReactNode;
  className?: string | undefined;
  testId?: string | undefined;
} & DataAttrs;

/** 進む：名前・値・›。to＝リンク（menu なら role="menuitem"）、onClick＝ボタン */
export function GroupNavRow({
  icon,
  title,
  sub,
  value,
  to,
  onClick,
  disabled,
  menu = false,
  current = false,
  titleTestId,
  buttonTestId,
  buttonId,
  valueTestId,
  className,
  testId,
  ...data
}: SetRowBase & {
  title: ReactNode;
  sub?: ReactNode;
  value?: ReactNode;
  to?: string | undefined;
  onClick?: (() => void) | undefined;
  disabled?: boolean | undefined;
  menu?: boolean;
  /** いまの行（PC の2列の左の列。地 --sel・太字・aria-current="page"） */
  current?: boolean;
  titleTestId?: string | undefined;
  buttonTestId?: string | undefined;
  /** 中のリンク・ボタンの id */
  buttonId?: string | undefined;
  valueTestId?: string | undefined;
}) {
  const inner = (
    <>
      <span className="gtx">
        <span className="gtt" data-testid={titleTestId}>
          {title}
        </span>
        {sub ? <span className="gsb">{sub}</span> : null}
      </span>
      {icon ? <span className="gico">{icon}</span> : null}
      <span className="gend">
        {value != null && value !== "" ? (
          <span className="gval" data-testid={valueTestId}>
            {value}
          </span>
        ) : null}
        <Chevron />
      </span>
    </>
  );
  return (
    <li className={join("grow grow-set grow-nav", icon ? "has-ico" : null, current && "is-current", className)} data-testid={testId} {...data}>
      {to ? (
        <Link className="growin" to={to} id={buttonId} role={menu ? "menuitem" : undefined} aria-current={current ? "page" : undefined} onClick={onClick} data-testid={buttonTestId}>
          {inner}
        </Link>
      ) : (
        <button type="button" className="growin" id={buttonId} role={menu ? "menuitem" : undefined} onClick={onClick} disabled={disabled} data-testid={buttonTestId}>
          {inner}
        </button>
      )}
    </li>
  );
}

/** 値：名前と、右に値（見るだけ）か部品（セグメントなど）。titleId＝名前の文の id（部品の aria-labelledby に） */
export function GroupValueRow({ icon, title, titleId, value, valueTestId, className, testId, ...data }: SetRowBase & { title: ReactNode; titleId?: string | undefined; value?: ReactNode; valueTestId?: string | undefined }) {
  return (
    <li className={join("grow grow-set grow-val", icon ? "has-ico" : null, className)} data-testid={testId} {...data}>
      <div className="growin">
        <span className="gtx">
          <span className="gtt" id={titleId}>
            {title}
          </span>
        </span>
        {icon ? <span className="gico">{icon}</span> : null}
        {value != null ? (
          <span className="gend">
            {typeof value === "string" ? (
              <Trunc testId={valueTestId}>{value}</Trunc>
            ) : (
              value
            )}
          </span>
        ) : null}
      </div>
    </li>
  );
}

/**
 * 入力：左に名前、右に欄（children は <input id={id} className="giinp" …>）。名前は <label htmlFor> なので getByLabel で探せる。
 * wide＝名前の幅 128px（#153 の自社情報。ふつうは 52px＝姓・名）。end＝欄の右に置くもの（「住所検索」）。
 * error＝行の下に朱の1行（#155 振込口座の足りない欄・見つからないコード。数の行と同じ形）。欄には aria-invalid と aria-describedby={`${id}-err`} を付ける
 */
export function GroupInputRow({ id, label, children, wide = false, end, error, className, testId, ...data }: { id: string; label: ReactNode; children: ReactNode; wide?: boolean; end?: ReactNode; error?: string | undefined; className?: string | undefined; testId?: string | undefined } & DataAttrs) {
  // スマホ版の浮く名前（S-00009）：空で打っていない欄は名前を欄の位置に。:placeholder-shown で見るので、生の <input> に placeholder " " を付ける（Field と同じ）
  const kids = Children.map(children, (c) => (isValidElement<{ placeholder?: string }>(c) && c.type === "input" && c.props.placeholder == null ? cloneElement(c, { placeholder: " " }) : c));
  return (
    <li className={join("grow grow-set grow-in", wide && "is-wide", error && "is-error", className)} data-testid={testId} {...data}>
      <div className="growin">
        <label className="gilbl" htmlFor={id}>
          {label}
        </label>
        {kids}
        {end ? <span className="giend">{end}</span> : null}
      </div>
      {error ? (
        <p className="gnerr" id={`${id}-err`} role="alert">
          {`⚠ ${error}`}
        </p>
      ) : null}
    </li>
  );
}

/** 上下のしるし（選ぶ行の右端） */
function UpDown() {
  return (
    <svg className="gupdown" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M7.5 9.5L12 5l4.5 4.5M7.5 14.5L12 19l4.5-4.5" />
    </svg>
  );
}

/**
 * 選ぶ（#153、docs/62 §3）：入力の行と同じ形（名前 128px・右に値 墨 17）＋右端に上下のしるし。
 * 中身は今のネイティブの <select>（行全体に重ねて透明＝押せる範囲は行全体。開くのは OS の選び方）。名前は <label htmlFor> なので getByLabel で探せる
 */
export function GroupSelectRow({
  id,
  label,
  value,
  options,
  onChange,
  disabled,
  placeholder,
  className,
  testId,
  selectTestId,
  ...data
}: {
  id: string;
  label: ReactNode;
  value: string;
  options: ReadonlyArray<{ value: string; label: string }>;
  onChange: (v: string) => void;
  disabled?: boolean | undefined;
  /** 値が空のときの字（選んでいない）。渡すと空の選択肢も出す */
  placeholder?: string | undefined;
  className?: string | undefined;
  testId?: string | undefined;
  selectTestId?: string | undefined;
} & DataAttrs) {
  const cur = options.find((o) => o.value === value);
  return (
    <li className={join("grow grow-set grow-in is-wide grow-sel", disabled && "is-disabled", className)} data-testid={testId} {...data}>
      <div className="growin">
        <label className="gilbl" htmlFor={id}>
          {label}
        </label>
        <span className={join("gselv", !cur && "is-none")} aria-hidden="true">
          {cur ? cur.label : (placeholder ?? "")}
        </span>
        <UpDown />
        <select id={id} className="gselinp" value={value} disabled={disabled} onChange={(e) => onChange(e.target.value)} data-testid={selectTestId}>
          {placeholder != null ? <option value="">{placeholder}</option> : null}
          {options.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
      </div>
    </li>
  );
}

/** 画像の見本（44px・白地・1px の枠・角丸 8・中に収める。無ければ点線の枠と「—」） */
export function ImageThumb({ url, alt, size = 44 }: { url?: string | null | undefined; alt: string; size?: number }) {
  const style = size === 44 ? undefined : ({ width: size, height: size } as CSSProperties);
  return url ? (
    <span className="gthumb" style={style}>
      <img src={url} alt={alt} />
    </span>
  ) : (
    <span className="gthumb is-none" style={style} aria-hidden="true">
      —
    </span>
  );
}

/**
 * 画像（#153、docs/62 §3。社印・ロゴ）：左に見本 44px・名前・右に「変更」か「未登録」・›。押すとシート（onClick）。
 * 行に画像のファイルを落としても登録できる（onDropFile。今どおり）
 */
export function GroupImageRow({
  label,
  url,
  value,
  onClick,
  onDropFile,
  busy = false,
  buttonTestId,
  className,
  testId,
  ...data
}: {
  label: string;
  url: string | null | undefined;
  /** 右の字（「変更」「未登録」） */
  value: string;
  onClick: () => void;
  onDropFile?: ((f: File) => void) | undefined;
  busy?: boolean;
  buttonTestId?: string | undefined;
  className?: string | undefined;
  testId?: string | undefined;
} & DataAttrs) {
  const [over, setOver] = useState(false);
  return (
    <li
      className={join("grow grow-set grow-img", over && "is-over", className)}
      data-testid={testId}
      aria-busy={busy || undefined}
      onDragOver={
        onDropFile
          ? (e) => {
              e.preventDefault();
              setOver(true);
            }
          : undefined
      }
      onDragLeave={onDropFile ? () => setOver(false) : undefined}
      onDrop={
        onDropFile
          ? (e) => {
              e.preventDefault();
              setOver(false);
              const f = e.dataTransfer.files?.[0];
              if (f) onDropFile(f);
            }
          : undefined
      }
      {...data}
    >
      <button type="button" className="growin" onClick={onClick} disabled={busy} data-testid={buttonTestId}>
        <span className="gtx">
          <span className="gtt">{label}</span>
        </span>
        <span className="gico">
          <ImageThumb url={url} alt={label} />
        </span>
        <span className="gend">
          <span className="gval">{value}</span>
          <Chevron />
        </span>
      </button>
    </li>
  );
}

/**
 * 会社の頭の行（#153、docs/62 §2。Figma の部品「会社の頭の行」）：会社のアイコン 56・会社名（太字 18）・下の字（薄墨 14）・›。
 * to があれば押せる（自社情報へ）。無ければ押せない（担当者：›なし）。current＝PC の2列でいまの行
 */
export function GroupHeadRow({ icon, title, sub, to, current = false, buttonId, titleTestId, className, testId, ...data }: SetRowBase & { title: ReactNode; sub?: ReactNode; to?: string | undefined; current?: boolean; buttonId?: string | undefined; titleTestId?: string | undefined }) {
  const inner = (
    <>
      <span className="gtx">
        <span className="gtt" data-testid={titleTestId}>
          {title}
        </span>
        {sub ? <span className="gsb">{sub}</span> : null}
      </span>
      {icon ? <span className="gico">{icon}</span> : null}
      {to ? (
        <span className="gend">
          <Chevron />
        </span>
      ) : null}
    </>
  );
  return (
    <li className={join("grow grow-set grow-head has-co", current && "is-current", className)} data-testid={testId} {...data}>
      {to ? (
        <Link className="growin" to={to} id={buttonId} aria-current={current ? "page" : undefined}>
          {inner}
        </Link>
      ) : (
        <div className="growin" id={buttonId}>
          {inner}
        </div>
      )}
    </li>
  );
}

/**
 * 朱：真ん中に朱の字（ログアウトなど）。押すとすぐ動くもの。to＝別の画面へ（退会。#153）。current＝PC の2列でいまの行。
 * tone="ai"＝藍の字（危なくない動き。分割の既定の「既定に戻す」。#154）
 */
export function GroupDangerRow({ title, onClick, to, current = false, disabled, menu = false, tone = "danger", buttonTestId, buttonId, className, testId, ...data }: { title: ReactNode; onClick?: (() => void) | undefined; to?: string | undefined; current?: boolean; disabled?: boolean | undefined; menu?: boolean; tone?: "danger" | "ai"; buttonTestId?: string | undefined; buttonId?: string | undefined; className?: string | undefined; testId?: string | undefined } & DataAttrs) {
  const inner = (
    <span className="gtx">
      <span className="gtt">{title}</span>
    </span>
  );
  return (
    <li className={join("grow grow-set grow-danger", tone === "ai" && "is-ai", current && "is-current", className)} data-testid={testId} {...data}>
      {to ? (
        <Link className="growin" to={to} id={buttonId} role={menu ? "menuitem" : undefined} aria-current={current ? "page" : undefined} onClick={onClick} data-testid={buttonTestId}>
          {inner}
        </Link>
      ) : (
        <button type="button" className="growin" id={buttonId} role={menu ? "menuitem" : undefined} onClick={onClick} disabled={disabled} data-testid={buttonTestId}>
          {inner}
        </button>
      )}
    </li>
  );
}

// ---------------------------------------------------------------------------
// 見積・請求（#154）：スイッチ・数・分割の回
// ---------------------------------------------------------------------------

/**
 * スイッチ（#154、docs/63 §2）：左に名前（墨 16・折り返してよい）、右にトグル 52×32。
 * 2026-10-21 射場さん（docs/89 ★15）：右の「オン／オフ」「使う／使わない」の字はやめた＝つまみ＋名前だけ（状態はつまみの位置と色の両方で分かる）。
 * 行が <label> なので、行のどこを押しても（名前も）切り替わる。中身は今の Switch と同じ（role="switch"・aria-checked・aria-label は短い名前）
 */
export function GroupSwitchRow({
  label,
  name,
  checked,
  onChange,
  disabled = false,
  lead = false,
  testId,
  rowTestId,
  className,
  ...data
}: {
  label: ReactNode;
  /** つまみを名前の左に（節の頭のスイッチ＝下の行がそのオン・オフで出る。{order}の設定の「{orderAck}」「約款」。#256） */
  lead?: boolean;
  /** 読み上げの名前（getByRole("switch", { name }) もこれ） */
  name: string;
  checked: boolean;
  onChange: (v: boolean) => void;
  disabled?: boolean | undefined;
  /** スイッチ（input）の data-testid */
  testId?: string | undefined;
  /** 行（li）の data-testid */
  rowTestId?: string | undefined;
  className?: string | undefined;
} & DataAttrs) {
  return (
    <li className={join("grow grow-set grow-sw", lead && "is-lead", disabled && "is-disabled", className)} data-testid={rowTestId} {...data}>
      <label className="growin">
        {lead ? null : (
          <span className="gtx">
            <span className="gtt">{label}</span>
          </span>
        )}
        <span className="gend sw">
          <input type="checkbox" role="switch" aria-checked={checked} aria-label={name} checked={checked} disabled={disabled} onChange={(e) => onChange(e.target.checked)} data-testid={testId} />
          <span className="track" aria-hidden="true">
            <span className="thumb" />
          </span>
        </span>
        {lead ? (
          <span className="gtx">
            <span className="gtt">{label}</span>
          </span>
        ) : null}
      </label>
    </li>
  );
}

/**
 * 数（#154、docs/63 §2）：左に名前、右に地 --head の欄（112×36・右寄せ。NumInput＝テンキー・全角→半角、int は欄を出ると3桁ごとの「,」）と単位。
 * 入力中は白地に藍の輪。error＝範囲の外などの朱の1行（行の下）。名前は <label htmlFor> なので getByLabel で探せる
 */
export function GroupNumberRow({
  id,
  label,
  kind,
  value,
  onChange,
  unit,
  error,
  disabled = false,
  inputTestId,
  className,
  testId,
  showZero,
  ...data
}: {
  id: string;
  label: ReactNode;
  /** int＝整数（桁区切りで見せる）／dec＝小数 */
  kind: "int" | "dec";
  /** 0 を「0」と見せる（NumInput の showZero） */
  showZero?: boolean | undefined;
  value: number | null;
  onChange: (v: number | null) => void;
  /** 欄の右の単位（％・円） */
  unit: ReactNode;
  error?: string | undefined;
  disabled?: boolean | undefined;
  inputTestId?: string | undefined;
  className?: string | undefined;
  testId?: string | undefined;
} & DataAttrs) {
  const errId = `${id}-err`;
  return (
    <li className={join("grow grow-set grow-num", error && "is-error", disabled && "is-disabled", className)} data-testid={testId} {...data}>
      <div className="growin">
        <label className="gtx gnlbl" htmlFor={id}>
          <span className="gtt">{label}</span>
        </label>
        <span className="gend">
          <NumInput kind={kind} id={id} className="gnum" value={value} showZero={showZero} disabled={disabled} aria-invalid={error ? true : undefined} aria-describedby={error ? errId : undefined} onChange={onChange} data-testid={inputTestId} />
          <span className="gunit">{unit}</span>
        </span>
      </div>
      {error ? (
        <p className="gnerr" id={errId} role="alert">
          {`⚠ ${error}`}
        </p>
      ) : null}
    </li>
  );
}

/**
 * 分割の回（#154、docs/63 §3、Figma ⑧）：左に ⊖（朱の丸。onRemove があるときだけ。gutter＝⊖ の無い行も同じ所から字を始める）・「n回目」（薄墨 15）・
 * 名前（行の中で入力。20文字まで）・割合の欄（地 --head・右寄せ・％）。rest＝最後の回（割合の代わりに「残り」）
 */
export function InstallmentRow({
  n,
  label,
  percent,
  rest,
  onLabel,
  onPercent,
  onRemove,
  gutter = false,
  disabled = false,
  nameId,
  percentId,
  nameLabel,
  percentLabel,
  restLabel,
  removeLabel,
  removeTestId,
  className,
  testId,
  ...data
}: {
  /** 「1回目」 */
  n: string;
  label: string;
  percent: number | null;
  rest: boolean;
  onLabel: (v: string) => void;
  onPercent: (v: number | null) => void;
  onRemove?: (() => void) | undefined;
  gutter?: boolean;
  disabled?: boolean | undefined;
  nameId: string;
  percentId: string;
  /** 読み上げの名前（「1回目の名前」「1回目の割合（%）」） */
  nameLabel: string;
  percentLabel: string;
  /** 最後の回の字（「残り」） */
  restLabel: string;
  /** ⊖ の読み上げ（「1回目を削除」） */
  removeLabel?: string | undefined;
  removeTestId?: string | undefined;
  className?: string | undefined;
  testId?: string | undefined;
} & DataAttrs) {
  return (
    <li className={join("grow grow-set grow-inst", className)} data-testid={testId} {...data}>
      <div className="growin">
        {onRemove ? (
          <button type="button" className="ginst-rm" aria-label={removeLabel} title={removeLabel} onClick={onRemove} data-testid={removeTestId}>
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <circle cx="12" cy="12" r="10" />
              <path d="M7.5 12h9" />
            </svg>
          </button>
        ) : gutter ? (
          <span className="ginst-sp" aria-hidden="true" />
        ) : null}
        <span className="ginst-n">{n}</span>
        <input id={nameId} className="ginst-name" value={label} maxLength={20} disabled={disabled} aria-label={nameLabel} onChange={(e) => onLabel(e.target.value)} />
        <span className="gend">
          {rest ? (
            <span className="ginst-rest">{restLabel}</span>
          ) : (
            <>
              <NumInput kind="dec" id={percentId} className="gnum is-short" value={percent} disabled={disabled} aria-label={percentLabel} onChange={onPercent} />
              <span className="gunit">%</span>
            </>
          )}
        </span>
      </div>
    </li>
  );
}

// ---------------------------------------------------------------------------
// 振込口座（#155）：口座の行・候補の行・文の行
// ---------------------------------------------------------------------------

/**
 * 口座の行（#155、docs/64 §2、Figma の部品「口座の行」）：68px・左に口座の絵 40・1行目＝銀行名 支店名（既定は太字＋右に ✓既定）・
 * 2行目＝sub（種別 口座番号　名義。薄墨 14）・›。行全体がリンク（replace＝一覧の上にシートが開く。閉じても履歴が増えない）
 */
export function BankAccountRow({ title, sub, isDefault, defaultLabel, to, className, testId, ...data }: { title: string; sub: ReactNode; isDefault: boolean; /** 「既定」 */ defaultLabel: string; to: string; className?: string | undefined; testId?: string | undefined } & DataAttrs) {
  return (
    <li className={join("grow grow-set grow-bank", isDefault && "is-default", className)} data-testid={testId} {...data}>
      <Link className="growin" to={to} replace>
        <span className="gtx">
          <span className="gtt gbank-l1">
            <span className="gbank-name">{title}</span>
            {isDefault ? (
              <span className="gdef">
                <CheckMark />
                {defaultLabel}
              </span>
            ) : null}
          </span>
          <span className="gsb">{sub}</span>
        </span>
        <span className="gico">
          <RowIcon k="bank" size={40} />
        </span>
        <span className="gend">
          <Chevron />
        </span>
      </Link>
    </li>
  );
}

/**
 * 候補のまとまり（#155、docs/64 §3 ⑭）：入力の行のすぐ下・同じまとまりの中の li に role="listbox"。id は欄の aria-controls に。
 * 中に GroupSuggestRow を並べる
 */
export function GroupSuggestList({ id, label, children, testId }: { id: string; /** 読み上げの名前（「銀行の候補」） */ label: string; children: ReactNode; testId?: string | undefined }) {
  return (
    <li className="grow grow-sugs" role="none">
      <ul id={id} role="listbox" aria-label={label} data-testid={testId}>
        {children}
      </ul>
    </li>
  );
}

/**
 * 候補の行（#155、Figma の部品「候補の行」）：48px・名前と右にコード（薄墨）。active＝↓↑ で選んでいる行（地 --sel＋太字・aria-selected）。
 * 押すと onPick（欄の focus は動かさない＝mousedown を止める）。id は欄の aria-activedescendant に
 */
export function GroupSuggestRow({ id, label, code, active, onPick, testId }: { id: string; label: string; code: string; active: boolean; onPick: () => void; testId?: string | undefined }) {
  return (
    <li id={id} role="option" aria-selected={active} className={join("grow grow-set grow-sug", active && "is-active")} data-testid={testId} onMouseDown={(e) => e.preventDefault()} onClick={onPick}>
      <span className="gsug-name">{label}</span>
      <span className="gsug-code">{code}</span>
    </li>
  );
}

/** 文の行（#155）：まとまりの中に文だけ（紙の印字・以前の振込先の1行。折り返してよい） */
export function GroupTextRow({ id, children, className, testId }: { id?: string | undefined; children: ReactNode; className?: string | undefined; testId?: string | undefined }) {
  return (
    <li className={join("grow grow-set grow-text", className)} data-testid={testId}>
      <div className="growin">
        <span className="gtxt" id={id}>
          {children}
        </span>
      </div>
    </li>
  );
}

// ---------------------------------------------------------------------------
// 設定の残り7画面（#156）：選ぶ行・2行の行・ユーザーの行・⊖
// ---------------------------------------------------------------------------

/** ⊖（朱の丸 22・押せる範囲 44）。分割の回の行と同じ形（.ginst-rm） */
export function RemoveButton({ label, onClick, disabled, testId }: { /** 読み上げの名前（「○○を削除」） */ label: string; onClick: () => void; disabled?: boolean | undefined; testId?: string | undefined }) {
  return (
    <button type="button" className="ginst-rm" aria-label={label} title={label} onClick={onClick} disabled={disabled} data-testid={testId}>
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="10" />
        <path d="M7.5 12h9" />
      </svg>
    </button>
  );
}

/**
 * 選ぶ行（#156、docs/65 §2）：名前（と補足 sub）・選んでいれば名前が太字＋右に ✓。
 *   1つ選ぶ（既定）＝中身は <button aria-pressed>（押した瞬間に保存する設定。業種の言葉・プリセット・よく使う言葉）
 *   いくつでも選ぶ（multi）＝行が <label>、中に見えない checkbox（id・getByLabel で探せる。退会の理由・確かめ）
 *   after＝行の右に重ねるもの（自分の書式の「修正」）
 */
export function GroupCheckRow({
  title,
  sub,
  checked,
  onChange,
  disabled = false,
  multi = false,
  radioName,
  inputId,
  after,
  buttonTestId,
  className,
  testId,
  ...data
}: {
  title: ReactNode;
  sub?: ReactNode;
  checked: boolean;
  /** 1つ選ぶ：押した（checked は渡したまま）／いくつでも：新しい値 */
  onChange: (v: boolean) => void;
  disabled?: boolean | undefined;
  multi?: boolean;
  /** 1つ選ぶをラジオボタンで（同じ名前の行で1組。#189 の自動ログアウト。読み上げは「ラジオボタン」） */
  radioName?: string | undefined;
  /** いくつでも：中の checkbox の id */
  inputId?: string | undefined;
  after?: ReactNode;
  /** 中のボタン（checkbox）の data-testid */
  buttonTestId?: string | undefined;
  className?: string | undefined;
  testId?: string | undefined;
} & DataAttrs) {
  const inner = (
    <>
      <span className="gtx">
        <span className="gtt">{title}</span>
        {sub ? <span className="gsb">{sub}</span> : null}
      </span>
      <span className="gend gchk-end">{checked ? <CheckMark /> : null}</span>
    </>
  );
  return (
    <li className={join("grow grow-set grow-chk", checked && "is-on", sub ? "has-sub" : null, disabled && "is-disabled", after ? "has-after" : null, className)} data-testid={testId} {...data}>
      {multi ? (
        <label className="growin">
          <input type="checkbox" className="gchk-inp" id={inputId} checked={checked} disabled={disabled} onChange={(e) => onChange(e.target.checked)} data-testid={buttonTestId} />
          {inner}
        </label>
      ) : radioName ? (
        <label className="growin">
          <input type="radio" className="gchk-inp" name={radioName} id={inputId} checked={checked} disabled={disabled} onChange={() => onChange(true)} data-testid={buttonTestId} />
          {inner}
        </label>
      ) : (
        <button type="button" className="growin" aria-pressed={checked} disabled={disabled} onClick={() => onChange(!checked)} data-testid={buttonTestId}>
          {inner}
        </button>
      )}
      {after}
    </li>
  );
}

/**
 * 2行の行（#156、docs/65 §2・§6）：名前と補足（薄墨 14）の2行＋›。行全体がリンク（to）。
 * editing＝「編集」の中：左に ⊖（onRemove）・› を隠す・行は押せない（iOS の編集の形）
 */
export function GroupTwoLineRow({
  title,
  sub,
  to,
  editing = false,
  onRemove,
  removeLabel,
  removeTestId,
  linkTestId,
  className,
  testId,
  ...data
}: {
  title: ReactNode;
  sub: ReactNode;
  to: string;
  editing?: boolean;
  onRemove?: (() => void) | undefined;
  removeLabel?: string | undefined;
  removeTestId?: string | undefined;
  /** 中のリンクの data-testid */
  linkTestId?: string | undefined;
  className?: string | undefined;
  testId?: string | undefined;
} & DataAttrs) {
  const tx = (
    <span className="gtx">
      <span className="gtt">{title}</span>
      <span className="gsb">{sub}</span>
    </span>
  );
  return (
    <li className={join("grow grow-set grow-two", editing && "is-editing", className)} data-testid={testId} {...data}>
      {editing ? (
        <div className="growin">
          {onRemove ? <RemoveButton label={removeLabel ?? ""} onClick={onRemove} testId={removeTestId} /> : null}
          {tx}
        </div>
      ) : (
        <Link className="growin" to={to} data-testid={linkTestId}>
          {tx}
          <span className="gend">
            <Chevron />
          </span>
        </Link>
      )}
    </li>
  );
}

/**
 * ユーザーの行（#156、docs/65 §5、Figma ⑲）：64px・人のアイコン 40（icon）・氏名（太字にしない）・2行目（sub。薄墨 14）・›。
 * dim＝行全体を薄く（使えない人）。行全体がリンク（replace＝一覧の上に修正のシートが開く。閉じても履歴が増えない）
 */
export function UserRow({ icon, title, sub, to, dim = false, className, testId, ...data }: { icon: ReactNode; title: ReactNode; sub: ReactNode; to: string; dim?: boolean; className?: string | undefined; testId?: string | undefined } & DataAttrs) {
  return (
    <li className={join("grow grow-set grow-user", dim && "is-dim", className)} data-testid={testId} {...data}>
      <Link className="growin" to={to} replace>
        <span className="gtx">
          <span className="gtt">{title}</span>
          <span className="gsb">{sub}</span>
        </span>
        <span className="gico">{icon}</span>
        <span className="gend">
          <Chevron />
        </span>
      </Link>
    </li>
  );
}
